import {Component, Input} from '@angular/core';
import {Image, Product} from '@spartacus/core';
import {TransactionType} from '@dcp/configurator';

@Component({
  selector: 'dcp-lead-form-product-details',
  templateUrl: './lead-form-product-details.component.html',
  styleUrls: ['./lead-form-product-details.component.scss']
})
export class LeadFormProductDetailsComponent {

  @Input() transactionType: TransactionType;
  @Input() image: Image;
  @Input() product: Product;
  @Input() showCtaFrom: boolean;
}
